import AppFrame from "components/AppFrame";
import { ProXtraFlowProvider } from "context";
import JobberCallback from "pages/JobberCallback";
import Error from "pages/Error";
import Step1 from "pages/Jobber-HomeDepot/Step1";
import Step2 from "pages/Jobber-HomeDepot/Step2";
import Step3 from "pages/Jobber-HomeDepot/Step3";
import {
    Navigate,
    Route,
    Routes as ReactRouterRoutes,
} from "react-router-dom";

const PROXTRA_LOGO = "/proxtra_logo.png";

const Routes = () => {
    return (
        <ReactRouterRoutes>
            <Route
                element={
                    <ProXtraFlowProvider>
                        <AppFrame logo={PROXTRA_LOGO} title="" />
                    </ProXtraFlowProvider>
                }
            >
                <Route
                    index
                    element={<Navigate to="/jobber-homedepot-step1" replace />}
                />
                <Route path="jobber-homedepot-step1" element={<Step1 />} />
                <Route path="jobber-homedepot-step2" element={<Step2 />} />
                <Route
                    path="jobber-homedepot-step3/:variant"
                    element={<Step3 />}
                />
                <Route path="error" element={<Error />} />
            </Route>
            <Route path="jobber/callback" element={<JobberCallback />} />
        </ReactRouterRoutes>
    );
};

export default Routes;
